import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      alignSelf: 'stretch',
      background: 'white',
      borderRadius: 12,
      boxShadow: `0px 0px 0px 1px ${colours.neutral[200]}`,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      padding: spacing(2),
      width: '100%',
    },
    rootNoBorder: {
      alignSelf: 'stretch',
      background: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      width: '100%',
    },
    headerContainer: {
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },
    headerContainerWithBadge: {
      alignItems: 'center',
      alignSelf: 'stretch',
      display: 'flex',
      gap: spacing(2),
      justifyContent: 'space-between',
    },
    titleSection: {
      alignItems: 'center',
      display: 'flex',
      gap: spacing(1),
    },
    settingsIcon: {
      height: 16,
      position: 'relative',
      width: 17,
    },
    headerTitle: {
      color: colours.neutral[600],
      fontFamily: 'Inter',
      fontSize: 14,
      fontWeight: 600,
    },
    chevronIcon: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '& svg': {
        color: colours.neutral[500],
      },
    },
    qualificationBadge: {
      alignItems: 'center',
      background: colours.success[50],
      borderRadius: 6,
      display: 'flex',
      flexShrink: 0,
      gap: spacing(1),
      height: 32,
      justifyContent: 'center',
      paddingBottom: 6,
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 6,
      'div[class*="headerContainerWithBadge"] &': {
        alignSelf: 'auto',
      },
      'div[class*="headerContainer"]:not([class*="headerContainerWithBadge"]) ~ * &': {
        alignSelf: 'stretch',
      },
      '& span': {
        color: colours.success[600],
        fontFamily: 'Inter',
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      },
    },
    qualificationIcon: {
      color: colours.success[500],
      fontSize: 12,
      height: 12,
      width: 12,
    },
    qualificationBadgeWarning: {
      alignItems: 'center',
      background: colours.warning[50],
      borderRadius: 6,
      display: 'flex',
      flexShrink: 0,
      gap: spacing(1),
      height: 32,
      justifyContent: 'center',
      paddingBottom: 6,
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 6,
      'div[class*="headerContainerWithBadge"] &': {
        alignSelf: 'auto',
      },
      'div[class*="headerContainer"]:not([class*="headerContainerWithBadge"]) ~ * &': {
        alignSelf: 'stretch',
      },
      '& span': {
        color: colours.warning[700],
        fontFamily: 'Inter',
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      },
    },
    qualificationWarningIcon: {
      color: colours.warning[700],
      fontSize: 12,
      height: 12,
      width: 12,
    },
    fieldsContainer: {
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      padding: spacing(1),
      gap: spacing(2),
    },
    fieldToggleRow: {
      alignItems: 'center',
      alignSelf: 'stretch',
      display: 'inline-flex',
      justifyContent: 'space-between',
    },
    fieldLabelContainer: {
      alignItems: 'center',
      display: 'flex',
      gap: spacing(2),
    },
    fieldLabel: {
      color: colours.neutral[900],
      fontFamily: 'Inter',
      fontSize: 14,
      fontWeight: 500,
    },
    fieldWarningIcon: {
      fontSize: 16,
      height: 16,
      width: 16,
      color: colours.warning[600],
    },
    switchContainer: {
      alignItems: 'flex-end',
      display: 'inline-flex',
      flexDirection: 'column',
      gap: spacing(1.25),
      justifyContent: 'flex-start',
    },
  });
